import { render } from "./IssuerProfileModal.vue?vue&type=template&id=7dc15617&scoped=true"
import script from "./IssuerProfileModal.vue?vue&type=script&lang=js"
export * from "./IssuerProfileModal.vue?vue&type=script&lang=js"

import "./IssuerProfileModal.vue?vue&type=style&index=0&id=7dc15617&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dc15617"]])

export default __exports__